module.exports = __webpack_public_path__ + "static/media/error.783ca1cd.svg";